export const PREVIOUS_PERIOD = "previous period";
export const PREVIOUS_YEAR = "previous year";

export type IPeriodOverPeriodCompareType = typeof PREVIOUS_PERIOD | typeof PREVIOUS_YEAR;
